import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import {
  Container, Segment, List, Grid, Image, Card, Icon, Header, Statistic,
  Form, Table, GridRow, Input, GridColumn, Select, Divider, Modal
} from 'semantic-ui-react'
import { YYYYMM, customerNo } from "../../utils/constant";
import QuicksightDashboard from '../dashboard/quicksightDashboard';
import IdleTimer from 'react-idle-timer'
import { icons } from 'react-icons/lib';
import ReadAxiosRequestAxios from '../../components/axiosComponent/allAxiosCommonRequest';
import { BarChart } from './barChart';
import UpdateAxios from "../../axiosComponent/update";
import ReadAxios from "../../components/axiosComponent/read";
import ModalEditAddDeliveries from "../../components/createShipmentComponent/modalEditAddDeliveries";
import { isTransportAllocationRequired } from "../../features/features";
import moment from 'moment';
var date = new Date();

export default class Dashboard extends Component {

  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      customerNumber: [],
      salesAndCollectionData: {},
      podTotalCollectionData: 0,
      dispatchTrackerTotalCollectionData: [],
      totalPOAndPayment: {},
      tripProfitabilityReportData: {},
      startDateFilter: date,
      endDateFilter: '',
      openModalDelivery: false,
      fleetStatus: [],
      setFleetModal: false,
      selectedFleet: [],
      tripProfitabilityReports: [],
      defaultFleatStatus: {
        "On Road/In-Transit": true,
        "WFL": true,
        "WFU": true,
        "Off Road/ Available": true,
        "Under R&M": true,
      },
      defaultFleetStatusLabels : {
        "On Road/In-Transit": "On Road/In-Transit",
        "WFL": "WFL",
        "WFU": "WFU",
        "Off Road/ Available": "Available",
        "Under R&M": "Under R&M",
      }
    };
    this.idleTimer = null
    this.handleOnAction = this.handleOnAction.bind(this)
    this.handleOnActive = this.handleOnActive.bind(this)
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  componentDidMount() {
    let customerNumberTemp = localStorage.getItem('customerNumber')
    this.setState({ customerNumber: customerNumberTemp })
    this.salesAndCollectionDashboard()
    this.dispatchTrackerTotalCollectionDashboard()
    this.podTotalCollectionDashboard()
    this.totalPOAndPayment({})
    this.getTripProfitabilityReport(new Date())
    this.fleetStatus()

    const startDate = moment(this.state.startDateFilter).format(YYYYMM);
    const endDate = moment(this.state.startDateFilter).add('month', 1).format(YYYYMM);
    this.getPoDs(startDate, endDate)
  }

  openDeliveryModal = (data, mode) => {
    console.log(data.delivery_id);
    console.log(mode);

    this.setState({ passMode: mode });

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${data.delivery_id}/delivery`,
    })
      .then((res) => {
        this.setState({
          deliveryDataFetch: res.data.data,
          clickedDeliveryID: res.data.data.delivery_id,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });

    this.setState({ openModalDelivery: true });
  };

  fleetStatus = () => {
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/dispatch/vehicleDashboardReport/${customerNo}`,
      method: "get",
    })
      .then((res) => {
        const defaultVal = this.state.defaultFleatStatus;
        this.setState({ fleetStatus: res.data.resultSet });
        res.data.resultSet && res.data.resultSet.length > 0 && res.data.resultSet.map((data) => {
          return defaultVal[data.vehicleStatusCode] ?
            defaultVal[data.vehicleStatusCode] = false : null;
        })
        this.setState({ defaultFleatStatus: defaultVal })
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  getPoDs = (startDate, endDate) => {
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/dispatch/pods/podCounts/${customerNo}/${startDate}-01/${endDate}-01`,
      method: "get",
    })
      .then((res) => {
        this.setState({ pods: res.data.resultSet });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  handleOnAction(event) {
    //console.log('user did something', event)
  }
  reDirect(e, to) {

    if (to == 'indent') { window.location.href = "/create-booking-request" }

    else if (to === 'deliveries') { this.props.history.push({ state: { displayNewDelivery: true } }); window.location.href = "/deliveries" }

    else if (to === 'add-shipment') { window.location.href = "/add-shipment" }

    else if (to === 'vendor') { window.location.href = "/add-vendor" }

    else if (to === 'vehicle') { window.location.href = "/vehicleavailability" }

    else if (to === 'consignor') { window.location.href = "/add-consignor" }

    else if (to === 'consignee') { window.location.href = "/add-consignee" }

    else if (to === 'add_billing_party') { window.location.href = "/add_billing_party" }
  }


  openDeliveryModal = (data, mode) => {
    console.log(data.delivery_id);
    console.log(mode);

    this.setState({ passMode: mode });

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${data.delivery_id}/delivery`,
    })
      .then((res) => {
        this.setState({
          deliveryDataFetch: res.data.data,
          clickedDeliveryID: res.data.data.delivery_id,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });

    this.setState({ openModalDelivery: true });
  };

  addDeliveryDetails = (deliveryData) => {
    UpdateAxios({
      patchURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${this.state.clickedDeliveryID}`,
      payload: { ...deliveryData[0] },
      uniqueId: this.state.clickedDeliveryID,
    })
      .then((response) => {
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setOpenModalDeliveryClose = () => {
    this.setState({ openModalDelivery: false });
  };




  salesAndCollectionDashboard(filter) {
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/sales/dashboard`,
      method: "get",
      getValues: filter?.month && filter?.year ? `month=${filter.month}&year=${filter.year}&` : ''
      //year=month=
    })
      .then((res) => {
        console.log("salesAndCollectionDashboard", res);
        let data = res.data.data;
        this.setState({ salesAndCollectionData: data })
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  dispatchTrackerTotalCollectionDashboard() {
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/dispatch/dispatchTrip/getSCCTAllTripsCount`,
      method: "get",
    })
      .then((res) => {
        console.log("dispatchTrackerTotalCollectionDashboard", res);
        let data = res.data.data;
        this.setState({ dispatchTrackerTotalCollectionData: data })
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  podTotalCollectionDashboard() {
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/pod/pod_total_count`,
      method: "get",
    })
      .then((res) => {
        console.log("podTotalCollectionDashboard", res);
        let data = res.data.resultSet;
        this.setState({ podTotalCollectionData: data })
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  totalPOAndPayment(filter) {
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/purchase/dashboard/getDashboard`,
      method: "get",
      getValues: filter?.startDate && filter?.endDate ? `startDate=${filter.startDate}&endDate=${filter.endDate}&` : ''
    })
      .then((res) => {
        console.log("totalPOAndPayment", res);
        let data = res.data.data;
        this.setState({ totalPOAndPayment: data })
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  getTripProfitabilityReport(date) {
    let todaysDate = date;
    let yearMonth = todaysDate.getFullYear() + '-' + (todaysDate.getMonth() + 1);
    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_BASE_COMMON}/dispatch/settlementController/getTripProfitabilityReport?yearMonth=${yearMonth}&`,
      method: "get",
      noQ: true
    })
      .then((res) => {
        console.log("getTripProfitabilityReport", res);
        let data = res.data.data;
        this.setState({ tripProfitabilityReportData: data })
        const tripData = []
        Object.entries(data).forEach(
          ([key, value]) => {
            if (key != 'Owned_Total_Deductions' && key != 'Market_Total_Deductions' && key != 'Cost_for_Vehicle_Maintenance') {
              return (tripData.push({ key: key.replaceAll('_', ' '), value }))
            }
          })
        this.setState({ tripProfitabilityReports: tripData })
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  submitFilterData() {
    if (this.state.startDateFilter/*  && this.state.endDateFilter */) {
      let startDate = this.state.startDateFilter.getDate() + '-' + (this.state.startDateFilter.getMonth() + 1) + '-' + this.state.startDateFilter.getFullYear()
      //let endDate = this.state.endDateFilter.getDate() + '-' + (this.state.endDateFilter.getMonth() + 1) + '-' + this.state.endDateFilter.getFullYear()
      let totalDays = moment(this.state.startDateFilter).endOf('month');
      let days = totalDays.format('D') - 1;
      console.log(startDate)
      console.log(days)

      let endDateFormat = moment(this.state.startDateFilter, "DD-MM-YYYY").add(days, 'days')
      console.log(endDateFormat)
      console.log(endDateFormat.format('D'))
      console.log(endDateFormat.format('MM'))
      console.log(endDateFormat.format('YYYY'))
      let endDate = endDateFormat.format('D') + '-' + endDateFormat.format('M') + '-' + endDateFormat.format('YYYY')
      //console.log(endDate.format('D'))
      this.totalPOAndPayment({ startDate: startDate, endDate: endDate })
      this.salesAndCollectionDashboard({ month: (this.state.startDateFilter.getMonth() + 1), year: this.state.startDateFilter.getFullYear() })
      this.getTripProfitabilityReport(this.state.startDateFilter)
      const startPodDate = moment(this.state.startDateFilter).format(YYYYMM);
      const endPodDate = moment(this.state.startDateFilter).add('month', 1).format(YYYYMM);
      this.getPoDs(startPodDate, endPodDate)
    }
  }

  handleOnActive(event) {
    //console.log('user is active', event)
    //console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  handleOnIdle(event) {
    //console.log('user is idle', event)
    //console.log('last active', this.idleTimer.getLastActiveTime())
    window.location.href = "/shipment"
  }

  render() {
    const { t } = this.props;
    console.log(this.props, 'helloooo')
    return (
      <React.Fragment>
        <div id="dispatch_bar">
          <div className="container-fluid dip_bar">
            <div className="row">
              <div className="col-sm-12">
                <div className="d-flex justify-content-between">
                  <h2 className="page-title">Dashboard</h2>
                  {/* <div className='right mt-2'>
                    <button
                      size="mini"
                      className="grey-btn"
                      color="#f1f1f1"
                      icon
                    >
                      <Icon name="filter" size="small" />
                      Filter
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid dip_bar">
            <div className="row">
              <div className="col-sm-10">
                <div className="d-flex justify-content-between left">
                  <div class="ui form">
                    <div class="ui form">
                      <div class="inline fields">
                        <label>Month</label>
                        <div class="field display-flex-center-justify-center border-style-div">
                          {/* <input type="text" placeholder="01-02-2022 To 07-02-2022" className='round-input'></input> */}
                          <DatePicker className='border-none-input width-100px'
                            selected={this.state.startDateFilter}
                            maxDate={this.state.endDateFilter} dateFormat="MM/yyyy" placeholderText='From Month' showMonthYearPicker onChange={(date) => this.setState({ startDateFilter: date })} />
                          {/* <span>-</span> */}
                          {/* <DatePicker className='border-none-input width-100px' minDate={this.state.startDateFilter} selected={this.state.endDateFilter} dateFormat="MM/yyyy" placeholderText='To Date' showMonthYearPicker onChange={(date) => this.setState({ endDateFilter: date })} /> */}
                        </div>
                        {/* <label>Division</label>
                        <div class="field">
                          <Select placeholder="Select Division" className="round-input"></Select>
                        </div>
                        <label>Branch</label>
                        <div class="field">
                          <Select placeholder="Select Branch" className="round-input"></Select>
                        </div>

                        <label>Zone</label>
                        <div class="field">
                          <Select placeholder="Select Zone" className="round-input"></Select>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-sm-2'>
                <button type="button"
                  onClick={() => { this.submitFilterData() }}
                  className="ui button w3-round button-group-mt w3-blue mt-header-button" style={{ float: 'inline-end' }}>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='dashboard-container fluid width-100cent display-flex-center-justify-spacebtwn'>
          <Segment className="graph-container-context m-tb-0 mr-2 width-70cent">
            <div className="left list-box mb-5 mt-1">
              <List>
                <List.Item className='graph-list mb-4'><span className='list-width'>Total Revenue</span><span className='blue'><b><i class="rupee icon"></i>
                  {this.state.tripProfitabilityReportData.Overall_Revenue_in_Month}
                </b></span></List.Item>
                <List.Item className='graph-list mb-4'><span className='list-width'>Total Expenses</span><span className='red'><b><i class="rupee icon"></i>
                  {this.state.tripProfitabilityReportData.Overall_Cost_in_Month}
                </b></span></List.Item>
                <List.Item className='graph-list mb-4'><span className='list-width'>Profitability</span><span className='green'><b><i class="rupee icon"></i>
                  {this.state.tripProfitabilityReportData.Overall_Profit_in_Month}
                </b></span></List.Item>
              </List>
            </div>
            {
              isTransportAllocationRequired() ?
                <div className='right graph-bar width-100cent'>
                  <Table definition style={{ display: 'inline-flex' }}>
                    <Table.Body>
                      {
                        this.state.tripProfitabilityReports && this.state.tripProfitabilityReports.map(({ key, value }, index) => this.state.tripProfitabilityReports.length / 2 < index + 1 ? <Table.Row><Table.Cell>{key}</Table.Cell> <Table.Cell>{value}</Table.Cell></Table.Row> : null)
                      }
                    </Table.Body>
                    <Table.Body style={{ marginTop: "-3px" }}>
                      {
                        this.state.tripProfitabilityReports && this.state.tripProfitabilityReports.map(({ key, value }, index) => this.state.tripProfitabilityReports.length / 2 > index + 1 ? <Table.Row><Table.Cell>{key}</Table.Cell> <Table.Cell>{value}</Table.Cell></Table.Row> : null)
                      }
                    </Table.Body>
                  </Table>
                </div>
                : null
            }
          </Segment>

          <div className="width-28cent display-grid-center">

            <div className="reports-container-context mr-2 p-notallow">
              <h6 header className='ui attached pt-2 pl-2'>
                Reports
                {/* <Icon className='ml-5 cursor-pointer' name="refresh" color='blue' size="small"  /> */}
              </h6>
              <Divider></Divider>
              <div class="ui attached segment no-border">
                <Grid columns={2} relaxed stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <div className='reports-box mt-2'>
                        <div className='image-icon'>
                          <img src={"assets/img/addvehicle.png"} />
                        </div>
                        <center className="mt-2">Add Vehicle</center>
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div className='reports-box mt-2'>
                        <div className='image-icon'>
                          <img src={"assets/img/addbooking.png"} />
                        </div>
                        <center className="mt-2">Add Booking</center>
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div className='reports-box mt-2'>
                        <div className='image-icon'>
                          <img src={"assets/img/lorryrecipt.png"} />
                        </div>
                        <center className="mt-2">Add lorry recipt</center>
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div className='reports-box mt-2'>
                        <div className='image-icon'>
                          <img src={"assets/img/addtrip.png"} />
                        </div>
                        <center className="mt-2">Add Trip</center>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>

            <div className='graph-container-context-2 mt-3'>

              <h6 header className='ui attached pt-2 pl-2'>
                Quick Links
                {/* <Icon className='ml-5 cursor-pointer' name="refresh" color='blue' size="small" /> */}
              </h6>
              <Divider></Divider>
              <div class="ui attached segment no-border">
                <Grid container columns={2} relaxed stackable>
                  <Grid.Column>
                    <div className='link-text' onClick={(e) => { this.reDirect(e, 'indent') }} style={{ cursor: 'pointer' }}>
                      Add a New Booking
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div onClick={(e) => this.setState({ openModalDelivery: true })} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Generate LR </div>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div onClick={(e) => { this.reDirect(e, 'add-shipment') }} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Add a New Trip</div>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div onClick={(e) => { this.reDirect(e, 'vendor') }} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Add New Vendor</div>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div onClick={(e) => { this.reDirect(e, 'vehicle') }} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Add New Vehicle</div>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div onClick={(e) => { this.reDirect(e, 'consignor') }} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Add New Consignor</div>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div onClick={(e) => { this.reDirect(e, 'consignee') }} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Add New Consignee</div>
                    </div>
                  </Grid.Column>

                  <Grid.Column>
                    <div onClick={(e) => { this.reDirect(e, 'add_billing_party') }} style={{ cursor: 'pointer' }}>
                      <div className='link-text'>Add new Customer</div>
                    </div>
                  </Grid.Column>

                </Grid>
              </div>
            </div>


          </div>

        </div >


        <div className='dashboard-container fluid'>

          <div className='revenue-container-context left no-border'>
            <h3 class="ui top attached header top-margin-0 display-flex-center-justify-spacebtwn">
              Revenue
              {/*  {/* <Icon className='cursor-pointer' name="refresh" color='blue' size="small" /> */}
            </h3>
            <div class="ui attached segment">
              <Grid container columns={5} relaxed stackable>

                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'>Target of the Month</div>
                    <Statistic size='small'>
                      <Statistic.Value>
                        <b className='b-shd-1'> {this.state.salesAndCollectionData.targetSalesForMonth}</b>
                        {/* <b className='b-shd-1'>{this.state.salesAndCollectionData.targetCollectionForMonth}</b> */}
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'>Sales for the day</div>
                    <Statistic size='small'>
                      <Statistic.Value>
                        <b className='b-shd-2'>{this.state.salesAndCollectionData.salesForDay}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'> Invoice generated today</div>
                    <Statistic size='small' className='mt-2'>
                      <Statistic.Value>
                        <b className='b-shd-3'>{this.state.salesAndCollectionData.invGeneratedForDay}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'>Sales of the Month</div>
                    <Statistic size='small'>
                      <Statistic.Value>
                        <b className='b-shd-4'>{this.state.salesAndCollectionData.salesForMonth}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'>Invoice generated  this Month</div>
                    <Statistic size='small'>
                      <Statistic.Value>
                        <b className='b-shd-5'>{this.state.salesAndCollectionData.invGeneratedForMonth}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'>  Balance Sales pending</div>
                    <Statistic size='small'>
                      <Statistic.Value>
                        <b className='b-shd-6'>{this.state.salesAndCollectionData.balSalesPending}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column style={{ padding: '10px 0px 10px 0px' }}>
                  <div className='revenue-box'>
                    <div className='revenue-label'> Run Rate Required</div>
                    <Statistic size='small'>
                      <Statistic.Value>
                        <b className='b-shd-7'>{this.state.salesAndCollectionData.invoiceAmtRunRateReq}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>


              </Grid>


            </div>

          </div>

          <div className='expense-container-context left'>
            <h6 class="ui top attached header top-margin-0 display-flex-center-justify-spacebtwn">
              Expense
              {/*  {/* <Icon className='cursor-pointer' name="refresh" color='blue' size="small" /> */}
            </h6>
            <div class="ui attached segment">
              <Grid container columns={1} relaxed stackable>

                <Grid.Column>
                  <div className='revenue-box'>
                    <div className='revenue-label'>Expense of the Month</div>
                    <Statistic size='small' color='red'>
                      <Statistic.Value>
                        <b>{this.state?.totalPOAndPayment?.monthWiseTotalPayment || 0}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className='revenue-box'>
                    <div className='revenue-label'>Expense for the day</div>
                    <Statistic size='small' color='yellow'>
                      <Statistic.Value>
                        <b>{this.state?.totalPOAndPayment?.todaysTotalPayment || 0}</b>
                      </Statistic.Value>
                    </Statistic>
                  </div>
                </Grid.Column>

              </Grid>
            </div>
          </div>





          <div className='expense-container-context left'>
            <h6 class="ui top attached header top-margin-0 display-flex-center-justify-spacebtwn">
              Top 5 Customers
              {/*  {/* <Icon className='cursor-pointer' name="refresh" color='blue' size="small" /> */}
            </h6>
            <div class="ui attached segment">
              <div className='customer-box' style={{ height: '240px!important;' }}>
                <Table basic='very' celled className=''>
                  <Table.Body className='table-tr-border-none'>
                    {this.state?.salesAndCollectionData?.topFiveCustomers?.length > 0 &&
                      this.state.salesAndCollectionData.topFiveCustomers.map((customer, i) => (
                        <Table.Row>
                          <Table.Cell>
                            <Header.Subheader>{customer.customerName}</Header.Subheader>
                          </Table.Cell>
                          <Table.Cell className='green'><b>{customer.revenue}</b></Table.Cell>

                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>

              </div>
            </div>

          </div>

          {/* <h6 class="ui top attached header top-margin-0">
              
            </h6> */}
          <div className='clear'></div>
          <div className='sales-container-context left'>
            <div className='sale-box'>
              <h6 header className='ui attached'>
                Sales Order
                {/* <Icon className='ml-5 cursor-pointer' name="refresh" color='blue' size="small" /> */}
              </h6>
              <Divider></Divider>
              <div>
                <span className='left sales-01'>
                  Target of the Month
                </span>
                <span className='left number'>

                  <b className='green'>{this.state.salesAndCollectionData?.targetInvForMonth}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  LR Generated Today
                </span>
                <span className='left number'>
                  <b className='green'>{this.state.salesAndCollectionData.lrGeneratedForDay}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  LR Generated this Month
                </span>
                <span className='left number'>
                  <b className='green'>{this.state.salesAndCollectionData.lrGeneratedForMonth}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  Sales Order Executed
                </span>
                <span className='left number'>
                  <b className='green'>{this.state.salesAndCollectionData.soExForDay}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  Sales Order Miss/Cancelled
                </span>
                <span className='left number'>
                  <b className='green'>0</b>
                </span>
              </div>


            </div>

            <div className='purchase-box'>
              <h6 header className='ui attached'>
                Purchase Order
                {/* <Icon className='ml-5 cursor-pointer' name="refresh" color='blue' size="small" /> */}
              </h6>
              <Divider></Divider>
              <div>
                <span className='left sales-01'>
                  Purchase Order Generated Today
                </span>
                <span className='left number'>
                  <b className='green'>{this.state.totalPOAndPayment.todaysTotalPO}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  PO Generated this Month
                </span>
                <span className='left number'>
                  <b className='green'>{this.state.totalPOAndPayment.monthWiseTotalPO}</b>
                </span>
              </div>




            </div>


            {/* <Grid columns='equal' className="">
                <Grid.Row>
                  <Grid.Column>
                  
              <Divider></Divider>
                   
                      <Table basic='very' celled>
                        <Table.Body className='table-tr-border-none'>
                          <Table.Row>
                            <Table.Cell>
                              <Header.Subheader></Header.Subheader>
                            </Table.Cell>
                            <Table.Cell className='green'><b></b></Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell>
                              <Header.Subheader></Header.Subheader>
                            </Table.Cell>
                            <Table.Cell className='green'><b></b></Table.Cell>
                          </Table.Row>

                        </Table.Body>
                      </Table>
                  
                  </Grid.Column>
                </Grid.Row>
              </Grid> */}

          </div>

          <div className='collection-container-context left'>
            <div className='sale-box left'>
              <h6 header className='ui attached'>
                Collection
                {/* <Icon className='ml-5 cursor-pointer' name="refresh" color='blue' size="small" /> */}
              </h6>
              <Divider></Divider>

              <div>
                <span className='left sales-01'>
                  Target of the Month
                </span>
                <span className='left number'>

                  <b className='blue'>{this.state.salesAndCollectionData.targetCollectionForMonth}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  Collection of the Day</span>
                <span className='left number'>

                  <b className='blue'>{this.state.salesAndCollectionData.collectionForDay}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  Collection for the Month
                </span>
                <span className='left number'>
                  <b className='blue'>{this.state.salesAndCollectionData.collectionForMonth}</b>
                </span>
              </div>


              <div>
                <span className='left sales-01'>
                  Balance Collection Pending</span>
                <span className='left number'>

                  <b className='blue'>{this.state.salesAndCollectionData.balCollectionPending}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  Run Rate Required
                </span>
                <span className='left number'>

                  <b className='blue'>{this.state.salesAndCollectionData.collectionAmtRunRateReq}</b>
                </span>
              </div>

            </div>



            <div className='purchase-box left'>
              <h6 header className='ui attached'>
                Payment
                {/* <Icon className='ml-5 cursor-pointer' name="refresh" color='blue' size="small" /> */}
              </h6>
              <Divider></Divider>
              <div>
                <span className='left sales-01'>
                  Payment Executed Today
                </span>
                <span className='left number'>
                  <b className='blue'>{this.state?.salesAndCollectionData?.paymentExForDay || 0}</b>
                </span>
              </div>

              <div>
                <span className='left sales-01'>
                  Payment Executed for this Month
                </span>
                <span className='left number'>
                  <b className='blue'>{this.state?.salesAndCollectionData?.paymentExForMonth || 0}</b>
                </span>
              </div>
            </div>

          </div>

          <div className='display-inlineflex '>
            <Segment className='ebaybills-container-context m-t_b-2 p-notallow'>
              <h3 className='top-margin-0 display-flex-center-justify-spacebtwn'>
                E-Way Bills
                {/*  {/* <Icon className='cursor-pointer' name="refresh" color='blue' size="small" /> */}
              </h3>
              <Grid columns={3}>
                <Grid.Row>
                  <Grid.Column>
                    <div className='eway-bill-box'>
                      <div className='label'>Generated</div>
                      <Statistic size='small' color='green'>
                        <Statistic.Value>
                          <b></b>
                        </Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box'>
                      <div className='label'>Cancelled</div>
                      <Statistic color='orange' size='small'>
                        <Statistic.Value><b></b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>

                  <Grid.Column>
                    <div className='eway-bill-box'>
                      <div className='label'>Rejected</div>
                      <Statistic color='teal' size='small'>
                        <Statistic.Value><b></b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box mt-3'>
                      <div className='label'>Transporter</div>
                      <Statistic color='violet ' size='small'>
                        <Statistic.Value><b></b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box mt-3'>
                      <div className='label'> Generated by Payers</div>
                      <Statistic color='pink ' size='small'>
                        <Statistic.Value><b></b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box mt-3'>
                      <div className='label'> Part B</div>
                      <Statistic color='olive ' size='small'>
                        <Statistic.Value><b></b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment className='pods-container-context left ml-2 m-t_b-2'>
              <h3 className='top-margin-0 display-flex-center-justify-spacebtwn'>
                PoDs
              </h3>
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column>
                    <div className='eway-bill-box'>
                      <div className='label'>Pending PoDs</div>
                      <Statistic color='red' size='small'>
                        <Statistic.Value><b>{this.state?.pods?.pendingPoDs || 0}</b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box'>
                      <div className='label'>PoDs not submitted</div>
                      <Statistic color='orange' size='small'>
                        <Statistic.Value><b>{this.state?.pods?.PoDsNotSubmitted || 0}</b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box mt-3'>
                      <div className='label'>PoDs intransit</div>
                      <Statistic color='green' size='small'>
                        <Statistic.Value><b>{this.state?.pods?.inTransitPoDs || 0}</b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='eway-bill-box mt-3'>
                      <div className='label'>Invoices not Raised</div>
                      <Statistic color='blue' size='small'>
                        <Statistic.Value><b>{this.state?.pods?.invoiceNotRaised || 0}</b></Statistic.Value>
                      </Statistic>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment className='fleet-container-context ml-2 m-t_b-2'>
              <table class="ui very basic aligned table">
                <thead>
                  <tr>
                    <th className='no-border'>Fleet Status</th>
                    <th className='no-border'><span className='red'>Primary  Fleet</span></th>
                    <th className='no-border'><span className='green'>Secondary Fleet</span></th>
                    <th className='no-border'> {/* <Icon className='cursor-pointer' name="refresh" color='blue' size="small" /> */}</th>
                  </tr>
                </thead>
                <tbody className='table-tr-border-none'>
                  {
                    this.state.fleetStatus && this.state.fleetStatus.length > 0 && this.state.fleetStatus.map((data) =>
                      <tr onClick={() => this.setState({ setFleetModal: true, selectedFleet: data.vehicles })}>
                        <td>{this.state.defaultFleetStatusLabels[data.vehicleStatusCode]}</td>
                        <td className='red'><center><b>{data.length}</b></center></td>
                        <td className='green'><center><b></b></center></td>
                      </tr>
                    )
                  }
                  {
                    Object.keys(this.state.defaultFleatStatus).map((key) => this.state.defaultFleatStatus[key] ?
                      <tr>
                        <td>{this.state.defaultFleetStatusLabels[key]}</td>
                        <td className='red'><center><b>00</b></center></td>
                        <td className='green'><center><b></b></center></td>
                      </tr>
                      : null
                    )
                  }
                </tbody>
              </table>
              <br></br>
            </Segment>
          </div>
        </div>


        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          timeout={1000 * 60 * 5}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />

        <ModalEditAddDeliveries
          size="large"
          btime={21}
          reqon={new Date()}
          t={t}
          //movement_type={this.state.selectedMovementType}
          deliveryDataFetch={this.state.deliveryDataFetch}
          OpenModel={this.state.openModalDelivery}
          handleClose={this.setOpenModalDeliveryClose}
          onlyDelivery={true}
          handleMovementType={this.handleMovementType}
          mode={this.state.passMode}
          addDeliveryDetails={this.addDeliveryDetails}
        />

        <Modal
          open={this.state.setFleetModal}
          onClose={() => this.setState({ setFleetModal: false })}
          size="fullscreen"
          style={{
            padding: '50px 0 50px 0'
          }}
        >
          <Modal.Header className="p-bold-100">
            <div className="d-flex justify-content-between">
              <label className="font-weight-normal">{"Vehicle Details"}</label>
              <div className="form-inline">
                <i
                  onClick={() => this.setState({ setFleetModal: false })}
                  className="fas fa-times"></i>
              </div>
            </div>
          </Modal.Header>
          <Modal.Content scrolling>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Vehicle Code</Table.HeaderCell>
                  <Table.HeaderCell>Vehicle Number</Table.HeaderCell>
                  <Table.HeaderCell>Vehicle Owner</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  this.state.selectedFleet && this.state.selectedFleet.map((data, index) =>
                    <Table.Row key={'brvalues' + `${index}`}>
                      <Table.Cell>{data.vehicleCode}</Table.Cell>
                      <Table.Cell>{data.vehicleNumber}</Table.Cell>
                      <Table.Cell>{data.vehicleOwner}</Table.Cell>
                    </Table.Row>
                  )
                }
              </Table.Body>
            </Table>
          </Modal.Content>
        </Modal>
      </React.Fragment >
    )
  }
}
